/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import { call, put, takeLatest } from 'redux-saga/effects';

import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* getListEmployees({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get('/users', { params: { ...payload } }));
    if (response?.status === 200) {
      yield put(Actions.getListEmployeesSuccess(response.data));
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getListEmployeesFailure(messages));
    }
  }
}

function* addEmployee({ payload }) {
  try {
    const response = yield call(() => axiosMicro.post('/register', payload));
    yield put(Actions.addEmployeeSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.addEmployeeFailure(messages));
    }
  }
}

function* editEmployee({ payload }) {
  try {
    const response = yield call(() => axiosMicro.patch(`/users/${payload.id}`, payload.body));
    if (response?.status === 200) {
      yield put(Actions.editEmployeeSuccess());
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.editEmployeeFailure(messages));
    }
  }
}

function* deleteEmployee({ payload }) {
  try {
    const response = yield call(() => axiosMicro.delete(`/users/${payload}`));
    yield put(Actions.deleteEmployeeSuccess());
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.deleteEmployeeFailure(messages));
    }
  }
}
function* getDetailEmployee({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(`/users/${payload}`));
    yield put(Actions.getDetailEmployeeSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getDetailEmployeeFailure(messages));
    }
  }
}

function* checkEmailExist({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(`/users?limit=1000&search=email:${payload}`));
    yield put(Actions.checkEmailExistSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.checkEmailExistFailure(messages));
    }
  }
}

function* checkEmailBackupExist({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(`/users?limit=1000&search=email_backup:${payload}`));
    yield put(Actions.checkEmailBackupExistSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.checkEmailBackupExistFailure(messages));
    }
  }
}

function* resetPassword({ payload }) {
  try {
    const response = yield call(() => axiosMicro.patch(`/users/${payload.id}`, payload));
    yield put(Actions.resetPasswordEmployeeSuccess());
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.resetPasswordEmployeeFailure(messages));
    }
  }
}

function* getAllGold({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(`/users/golds?${payload.params}&orderBy=id&sortedBy=desc`));

    if (response?.status === 200) {
      yield put(Actions.getAllGoldSuccess(response.data));
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getAllGoldFailure(messages));
    }
  }
}
function* getGold({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(`/users/golds?user_id=${payload.id}${payload.params}`));

    if (response?.status === 200) {
      yield put(Actions.getGoldSuccess(response.data));
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getGoldFailure(messages));
    }
  }
}
function* editGold({ payload }) {
  try {
    const response = yield call(() => axiosMicro.post('/users/golds', payload));
    if (response?.status === 200 || response?.status === 204) {
      yield put(Actions.editGoldSuccess());
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.editGoldFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.getListEmployeesRequest, getListEmployees);
  yield takeLatest(Actions.addEmployeeRequest, addEmployee);
  yield takeLatest(Actions.getDetailEmployeeRequest, getDetailEmployee);
  yield takeLatest(Actions.editEmployeeRequest, editEmployee);
  yield takeLatest(Actions.resetPasswordEmployeeRequest, resetPassword);
  yield takeLatest(Actions.deleteEmployeeRequest, deleteEmployee);
  yield takeLatest(Actions.checkEmailExistRequest, checkEmailExist);
  yield takeLatest(Actions.checkEmailBackupExistRequest, checkEmailBackupExist);
  yield takeLatest(Actions.editGoldRequest, editGold);
  yield takeLatest(Actions.getGoldRequest, getGold);
  yield takeLatest(Actions.getAllGoldRequest, getAllGold);
}
